import { Paragraph } from '../../Common/index.js'
import { Environment } from 'environment.js'
import { useNavigate } from 'react-router-dom'
import type React from 'react'
import { useModal } from '../../Modal/UseModal.js'
import { openFeedbackForm } from '../../../Services/Telemetry/Feedback.js'

export const Footer = () => {
  const nav = useNavigate()

  const { openModal } = useModal()

  return (
    <div className={'flex flex-row w-full h-fit'}>
      {/* <div className="bg-repeat-x bg-body-default" style={{ backgroundImage: "url('/footer-dna-sm.png')", opacity: 1 }}></div> */}
      <footer
        className="grow text-gray-600 flex content-center flex-col flex-wrap items-center"
        style={{ backgroundImage: "url('/footer-dna-sm.png')" }}
      >
        <div className="px-2 sm:px-6 md:px-16 pt-16 m-auto text-center fill-black">
          {/* <svg
            width="50"
            height="50"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            clipRule="evenodd"
            className="inline-block fill-current"
          >
            <path d="M22.672 15.226l-2.432.811.841 2.515c.33 1.019-.209 2.127-1.23 2.456-1.15.325-2.148-.321-2.463-1.226l-.84-2.518-5.013 1.677.84 2.517c.391 1.203-.434 2.542-1.831 2.542-.88 0-1.601-.564-1.86-1.314l-.842-2.516-2.431.809c-1.135.328-2.145-.317-2.463-1.229-.329-1.018.211-2.127 1.231-2.456l2.432-.809-1.621-4.823-2.432.808c-1.355.384-2.558-.59-2.558-1.839 0-.817.509-1.582 1.327-1.846l2.433-.809-.842-2.515c-.33-1.02.211-2.129 1.232-2.458 1.02-.329 2.13.209 2.461 1.229l.842 2.515 5.011-1.677-.839-2.517c-.403-1.238.484-2.553 1.843-2.553.819 0 1.585.509 1.85 1.326l.841 2.517 2.431-.81c1.02-.33 2.131.211 2.461 1.229.332 1.018-.21 2.126-1.23 2.456l-2.433.809 1.622 4.823 2.433-.809c1.242-.401 2.557.484 2.557 1.838 0 .819-.51 1.583-1.328 1.847m-8.992-6.428l-5.01 1.675 1.619 4.828 5.011-1.674-1.62-4.829z"></path>
          </svg> */}
          <Paragraph color="default" highlight={'none'}>
            spcfy GmbH
          </Paragraph>
          <Paragraph color="default" highlight={'none'}>
            Biodiversity Monitoring since 2019
          </Paragraph>
          <Paragraph color="default" highlight="none">
            Copyright © {new Date().getFullYear()} - All right reserved
          </Paragraph>
          <Paragraph color="default" highlight="none">
            Version {Environment.SENTRY_RELEASE_VERSION.substring(0, Environment.SENTRY_RELEASE_VERSION.lastIndexOf('.'))}
          </Paragraph>
        </div>
        <div className="flex flex-row flex-wrap px-2 sm:px-6 md:px-16 py-8 justify-center gap-6">
          <a href="https://www.linkedin.com/company/spcfy-gmbh" target="_blank" rel={'noreferrer'} className="">
            <svg style={{ color: '#0A66C2' }} className="w-6 h-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
            </svg>
          </a>
        </div>
        <div className="flex flex-row justify-center gap-4 text-primary-content underline pb-2">
          <Paragraph color={'default'}>
            <span className={'cursor-pointer'} onClick={() => nav('/legal/tos')}>
              Terms of Use
            </span>
          </Paragraph>
          <Paragraph>|</Paragraph>
          <Paragraph color={'default'}>
            <span className={'cursor-pointer'} onClick={() => nav('/legal/privacy')}>
              Privacy Policy
            </span>
          </Paragraph>
          <Paragraph>|</Paragraph>
          <Paragraph color={'default'}>
            <span className={'cursor-pointer'} onClick={() => nav('/legal/imprint')}>
              Imprint
            </span>
          </Paragraph>
          <Paragraph>|</Paragraph>
          <Paragraph color={'default'}>
            <span className="cursor-pointer" onClick={() => void openFeedbackForm()}>
              Report a Bug
            </span>
          </Paragraph>
          <Paragraph>|</Paragraph>

          <Paragraph color={'default'}>
            <span className="cursor-pointer" onClick={() => openModal('pipelineSettings', {})}>
              Evaluation Setup
            </span>
          </Paragraph>
          <Paragraph>|</Paragraph>
          <Paragraph color={'default'}>
            <span className="cursor-pointer" onClick={() => openModal('changelog', {})}>
              Changelog
            </span>
          </Paragraph>
        </div>
      </footer>
    </div>
  )
}
